import React from 'react'
import StudentNavbar from '../StudentNavbar'
import ChatComponent from '../pages/ChatComponent'

function ChatComponentPage() {
  return (
    <div>
      <StudentNavbar/>
      <ChatComponent/>
    </div>
  )
}

export default ChatComponentPage
